import { Request } from 'api';
import { AxiosResponse } from 'axios';

interface JobStatusResponse {
    job_id: string;
    status: string;
    results?: any;
    error?: string;
    meet_name?: string;
    total_results?: number;
    matched_count?: number;
    unmatched_count?: number;
}

type ReturnType = Promise<AxiosResponse<JobStatusResponse>>;

const getTrackEventJobStatus = (jobId: string): ReturnType => {
    return Request.get(`/workouts/track-events/jobs/${jobId}`);
};

export default getTrackEventJobStatus;
